import { authFetch } from "~/services/fetch";

export async function makeRequestToGetReportTotalEntryByAccuracyLocationAndUser({
    startDate,
    finishDate,
    contactCenterId,
    exportCSV = false,
}) {
    try {
        const response = await authFetch({
            url: '/report/total-entry-by-accuracy',
            method: 'POST',
            data: {
                start_date: startDate,
                finish_date: finishDate,
                contact_center_id: contactCenterId,
                export_csv: exportCSV,
            }
        });

        return response.data;

    } catch (error) {
        console.error('ERROR GENERATE REPORT', error)
        throw error
    }
}